import { FormControl, Select, MenuItem, Typography, Box } from "@mui/material";

const Dropdown = ({ label, id, name, value, onChange, options, ...props }) => {
  return (
    <Box sx={{ width: "100%", mb: 2.5 }}>
      <Typography
        component="label"
        htmlFor={id}
        sx={{
          display: "block",
          mb: 1,
          fontWeight: "bold",
          color: "#333",
        }}
      >
        {label}
      </Typography>
      <FormControl fullWidth>
        <Select
          id={id}
          name={name}
          value={value}
          size="small"
          onChange={onChange}
          sx={{ fontSize: "16px" }}
          {...props}
        >
          {options.map((option) => (
            <MenuItem
              key={typeof option === "object" ? option.value : option}
              value={typeof option === "object" ? option.value : option}
            >
              {typeof option === "object" ? option.label : option}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default Dropdown;
